import script from "./AppButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppButton.vue?vue&type=script&setup=true&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=7eed15f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eed15f2"]])

export default __exports__